<template>
    <b-container fluid>
        <b-overlay :show='loading'>
            <iq-card>
                <template slot="body">
                    <b-row v-if="circular">
                        <b-col md="12" class="pt-3">
                            <h4>{{$t('externalUser.circular')}}</h4>
                            <table class="table table-sm table-striped table-bordered">
                                <tr class="bg-primary">
                                    <th>{{currentLocale === 'en'? 'No.': 'নং.'}}</th>
                                    <th>{{$t('externalUser.fiscal_year')}}</th>
                                    <th>{{$t('externalUser.memo_no')}}</th>
                                    <th>{{$t('externalUser.training')}}</th>
                                    <th>{{$t('externalUser.start_date')}}</th>
                                    <th>{{$t('externalUser.end_date')}}</th>
                                    <th>{{$t('globalTrans.action')}}</th>
                                </tr>
                              <template v-if="circular.length > 0">
                                <tr  v-for="(item, index) in circular" :key="index">
                                  <td>{{$n(index +1, { useGrouping: false })}})</td>
                                  <td>{{ EngBangNum(GetYear(item.fiscal_year_id)) }}</td>
                                  <td>{{item.circular_memo_no}}</td>
                                  <td>{{currentLocale === 'en'? item.training_title.training_title: item.training_title.training_title_bn}}</td>
                                  <td>{{item.training_start_date| dateFormat}}</td>
                                  <td>{{item.training_end_date| dateFormat}}</td>
                                  <td>
                                    <b-button disabled v-if="item.application.find(item => item.trainee_main_id == trainee.id)" variant="success" class="mr-2">{{$t('externalUser.applied2')}}</b-button>
                                    <b-button v-b-modal.modal-5 @click="Apply(item.id)" v-else variant="primary" class="mr-2">{{$t('externalUser.apply')}}</b-button>
                                    <!-- <b-button  v-if="data.item.status != 4" v-b-modal.modal-5 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="edit(data.item, trainingElearningServiceBaseUrl + 'download-attachment?file=uploads/trainee/profile/'+data.item.trainee.photo)"><i class="ri-ball-pen-fill m-0"></i></b-button> -->
                                  </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr>
                                  <td colspan="7" class="text-center"> {{ (currentLocale == 'bn') ? 'তথ্য পাওয়া যায়নি' : 'Data not found' }}</td>
                                </tr>
                              </template>
                            </table>
                        </b-col>
                    </b-row>
                    <b-modal id="modal-5" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
                      <Form @loadlist="getUserInfo(logged_user)" :id="appId" />
                    </b-modal>
                </template>
            </iq-card>
        </b-overlay>
    </b-container>
</template>
<script>
    import { core } from '@/config/pluginInit'
    import Form from './Form'
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    // import { applicationApply, CircularList } from '../../api/routes'
    import { CircularList } from '../../api/routes'
    // import ConfirmationPopup from '@/Utils/confirmation-message'

    export default {
        props: ['id'],
        components: {
          Form
        },
        created () {
            // this.checkRetailer()
            const userId = this.$store.state.Auth.authUser.id
            if (userId) {
                this.logged_user = userId
                this.getUserInfo(userId)
            }
        },
        mounted () {
            core.index()
        },
        data () {
            return {
                logged_user: null,
                saved: false,
                isApproved: false,
                trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
                circular: [],
                trainee: [],
                appId: 0
            }
        },
        computed: {
            loading () {
                return this.$store.state.ExternalUser.static.loading
            },
            currentLocale () {
                return this.$i18n.locale
            },
            formTitle () {
              return this.$t('externalUser.application')
            }
        },
        watch: {
        },
        methods: {
          Apply (id) {
            this.appId = id
            },
            // Apply (id) {
            //     var message = window.vm.$t('externalUser.ready_apply')
            //     ConfirmationPopup(message, (response) => {
            //         if (response === true) {
            //             this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: true })
            //             RestApi.getData(trainingElearningServiceBaseUrl, applicationApply + id).then(response => {
            //                 this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: false })
            //                 if (response.success) {
            //                     this.getUserInfo(this.logged_user)
            //                   const notification = response.notification
            //                    if (notification && this.$store.state.emitNotification) {
              //                   this.$socket.emit('send-notification', notification)

             //                     }
            //                     this.$toast.success({
            //                         title: this.$t('globalTrans.success'),
            //                         message: this.$t('globalTrans.update_msg'),
            //                         color: '#D6E09B'
            //                     })
            //                 } else {
            //                     this.$toast.error({
            //                         title: this.$t('globalTrans.error'),
            //                         message: this.$t('globalTrans.operationFailed')
            //                     })
            //                 }
            //             })
            //         }
            //     })
            // },
            async getUserInfo (id) {
                this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: true })
                const result = await RestApi.getData(trainingElearningServiceBaseUrl, CircularList)
                this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: false })
                if (result.success) {
                    this.trainee = result.trainee
                    this.circular = result.circular.reverse()
                } else {
                    //  this.$router.push({ name: 'external_user.stall_participant.profile_update' })
                }
            },
            GetYear (id) {
                const list = this.$store.state.ExternalUser.commonObj.fiscalYearList.find(item => item.value === id)
                if (this.$i18n.locale === 'bn') {
                    return list.text_bn
                } else {
                    return list.text_en
                }
            },
          EngBangNum (n) {
            if (this.$i18n.locale === 'bn') {
              return n.replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d])
            } else {
              return n.replace(/[০-৯]/g, d => '০১২৩৪৫৬৭৮৯'.indexOf(d))
            }
          },
            GetTraining (id) {
                const list = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === id)
                if (this.$i18n.locale === 'bn') {
                    return list.text_bn
                } else {
                    return list.text_en
                }
            }
        }
    }
</script>
